import { render, staticRenderFns } from "./BillManagementDialog.vue?vue&type=template&id=674cbe48&scoped=true&"
import script from "./BillManagementDialog.vue?vue&type=script&lang=js&"
export * from "./BillManagementDialog.vue?vue&type=script&lang=js&"
import style0 from "./BillManagementDialog.vue?vue&type=style&index=0&id=674cbe48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674cbe48",
  null
  
)

export default component.exports